module.exports = __webpack_public_path__ + "static/media/playFail.d3347759.wav";